import { connect } from 'react-redux';
import DeployAgent from '../components/DeployAgent';

import {
  downloadAccountConfig,
  downloadChromebookConfig,
  getInstallers,
  closeReleaseNotes,
} from '../actions/account';

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  loading: state.account.loading,
  downloading: state.account.downloadingAgentConfig,
  releaseNotes: state.account.releaseNotes,
  features: state.account.features,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  downloadAccountConfig: () => {
    dispatch(downloadAccountConfig());
  },
  downloadChromebookConfig: () => {
    dispatch(downloadChromebookConfig());
  },
  closeReleaseNotes: () => {
    dispatch(closeReleaseNotes());
  },
  initData: () => {
    dispatch(getInstallers());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeployAgent);
